import React from 'react';
import { Card, CardBody } from './../../components/card/card.jsx';
import { NavScrollTo } from './../../components/nav-scroll-to/nav-scroll-to.jsx';
import { Icon } from '@iconify/react';

function Settings() {
	return (
		<div>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<div id="general" className="mb-5">
									<h4 className="d-flex align-items-center mb-1"><Icon icon="solar:user-outline" className="text-white text-opacity-50 fs-18px me-2 my-n2" /> General</h4>
									<p className="text-white text-opacity-50 small">View and update your general account information and settings.</p>
									<Card>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Name</div>
												<div className="text-white">Sean Ngu</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Username</div>
												<div className="text-white">@seantheme</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Phone</div>
												<div className="text-white">+1-202-555-0183</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Email address</div>
												<div className="text-white">support@seantheme.com</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Password</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
									</Card>
								</div>
								
								<div id="notifications" className="mb-5">
									<h4 className="d-flex align-items-center mb-1"><Icon icon="solar:notification-unread-lines-outline" className="text-white text-opacity-50 fs-18px me-2 my-n2" /> Notifications</h4>
									<p className="text-white text-opacity-50 small">Enable or disable what notifications you want to receive.</p>
									<Card>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Comments</div>
												<div className="text-white d-flex align-items-center">
													<i className="fa fa-circle fs-4px fa-fw text-success me-2"></i> Enabled (Push, SMS)
												</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Tags</div>
												<div className="text-white d-flex align-items-center">
													<i className="fa fa-circle fs-4px fa-fw text-white text-opacity-25 me-2"></i> Disabled
												</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Reminders</div>
												<div className="text-white d-flex align-items-center">
													<i className="fa fa-circle fs-4px fa-fw text-success me-2"></i> Enabled (Push, Email, SMS)
												</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">New orders</div>
												<div className="text-white d-flex align-items-center">
													<i className="fa fa-circle fs-4px fa-fw text-success me-2"></i> Enabled (Push, Email, SMS)
												</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
									</Card>
								</div>
								
								<div id="privacyAndSecurity" className="mb-5">
									<h4 className="d-flex align-items-center mb-1"><Icon icon="solar:shield-network-outline" className="text-white text-opacity-50 fs-18px me-2 my-n2" /> Privacy and security</h4>
									<p className="text-white text-opacity-50 small">Limit the account visibility and the security settings for your website.</p>
									<Card>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Who can see your future posts?</div>
												<div className="text-white d-flex align-items-center">
													Friends only
												</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Photo tagging</div>
												<div className="text-white d-flex align-items-center">
													<i className="fa fa-circle fs-4px fa-fw text-success me-2"></i> Enabled
												</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Location information</div>
												<div className="text-white d-flex align-items-center">
													<i className="fa fa-circle fs-4px fa-fw text-white text-opacity-25 me-2"></i> Disabled
												</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Firewall</div>
												<div className="text-white d-block d-xl-flex align-items-center">
													<div className="d-flex align-items-center"><i className="fa fa-circle fs-4px fa-fw text-white text-opacity-25 me-2"></i> Disabled</div>
													<span className="bg-warning bg-opacity-10 text-warning ms-xl-3 mt-1 d-inline-block mt-xl-0 px-1">
														<i className="fa fa-exclamation-circle text-warning fs-12px me-1"></i> 
														<span className="text-warning">Please enable the firewall for your website</span>
													</span>
												</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
									</Card>
								</div>
								
								<div id="payment" className="mb-5">
									<h4 className="d-flex align-items-center mb-1"><Icon icon="solar:card-2-outline" className="text-white text-opacity-50 fs-18px me-2 my-n2" /> Payment</h4>
									<p className="text-white text-opacity-50 small">Manage your website payment provider</p>
									<Card>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Allowed payment method</div>
												<div className="text-white">
													Paypal, Credit Card, Apple Pay, Amazon Pay, Google Wallet, Alipay, Wechatpay
												</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
									</Card>
								</div>
								
								<div id="shipping" className="mb-5">
									<h4 className="d-flex align-items-center mb-1"><Icon icon="solar:box-outline" className="text-white text-opacity-50 fs-18px me-2 my-n2" /> Shipping</h4>
									<p className="text-white text-opacity-50 small">Allowed shipping area and zone setting</p>
									<Card>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Allowed shipping method</div>
												<div className="text-white">Local, Domestic</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
									</Card>
								</div>
								
								<div id="mediaAndFiles" className="mb-5">
									<h4 className="d-flex align-items-center mb-1"><Icon icon="solar:folder-with-files-outline" className="text-white text-opacity-50 fs-18px me-2 my-n2" /> Media and Files</h4>
									<p className="text-white text-opacity-50 small">Allowed files and media format upload setting</p>
									<Card>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Allowed files and media format</div>
												<div className="text-white">.png, .jpg, .gif, .mp4</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Media and files cdn</div>
												<div className="text-white d-flex align-items-center">
													<i className="fa fa-circle fs-4px fa-fw text-white text-opacity-25 me-2"></i> Disabled
												</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
									</Card>
								</div>
								
								<div id="languages" className="mb-5">
									<h4 className="d-flex align-items-center mb-1"><Icon icon="solar:global-outline" className="text-white text-opacity-50 fs-18px me-2 my-n2" /> Languages</h4>
									<p className="text-white text-opacity-50 small">Language font support and auto translation enabled</p>
									<Card>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Language enabled</div>
												<div className="text-white">English (default), Chinese, France, Portuguese, Japense</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Auto translation</div>
												<div className="text-white d-flex align-items-center">
													<i className="fa fa-circle fs-4px fa-fw text-success me-2"></i> Enabled
												</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Edit</a>
											</div>
										</CardBody>
									</Card>
								</div>
								
								<div id="system" className="mb-5">
									<h4 className="d-flex align-items-center mb-1"><Icon icon="solar:settings-outline" className="text-white text-opacity-50 fs-18px me-2 my-n2" /> System</h4>
									<p className="text-white text-opacity-50 small">System storage, bandwidth and database setting</p>
									<Card>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Web storage</div>
												<div className="text-white">40.8gb / 100gb</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-outline-theme btn-sm w-80px">Manage</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Monthly bandwidth</div>
												<div className="text-white">Unlimited</div>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Database</div>
												<div className="text-white">MySQL version 8.0.19</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-sm btn-success opacity-3 w-80px disabled">Update</a>
											</div>
										</CardBody>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Platform</div>
												<div className="text-white">PHP 7.4.4, NGINX 1.17.0</div>
											</div>
											<div>
												<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-sm btn-success w-80px">Update</a>
											</div>
										</CardBody>
									</Card>
								</div>
								
								<div id="resetSettings" className="mb-5">
									<h4 className="d-flex align-items-center mb-1"><Icon icon="solar:refresh-outline" className="text-white text-opacity-50 fs-18px me-2 my-n2" /> Reset settings</h4>
									<p className="text-white text-opacity-50 small">Reset all website setting to factory default setting.</p>
									<Card>
										<CardBody className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="text-white text-opacity-50">Reset Settings</div>
												<div className="text-white">This action will clear and reset all the current website setting.</div>
											</div>
											<div>
												<a href="#/" className="btn btn-sm btn-white w-80px">Reset</a>
											</div>
										</CardBody>
									</Card>
								</div>
							</div>
						
							<div className="col-xl-3">
								<NavScrollTo>
									<nav className="nav">
										<a className="nav-link" href="#general" data-toggle="scroll-to">General</a>
										<a className="nav-link" href="#notifications" data-toggle="scroll-to">Notifications</a>
										<a className="nav-link" href="#privacyAndSecurity" data-toggle="scroll-to">Privacy and security</a>
										<a className="nav-link" href="#payment" data-toggle="scroll-to">Payment</a>
										<a className="nav-link" href="#shipping" data-toggle="scroll-to">Shipping</a>
										<a className="nav-link" href="#mediaAndFiles" data-toggle="scroll-to">Media and Files</a>
										<a className="nav-link" href="#languages" data-toggle="scroll-to">Languages</a>
										<a className="nav-link" href="#system" data-toggle="scroll-to">System</a>
										<a className="nav-link" href="#resetSettings" data-toggle="scroll-to">Reset settings</a>
									</nav>
								</NavScrollTo>
							</div>
						</div>
					</div>
				</div>
			</div>
	
			<div className="modal fade" id="modalEdit">
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">Edit name</h5>
							<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
						</div>
						<div className="modal-body">
							<div className="mb-3">
								<label className="form-label">Name</label>
								<div className="row row-space-10">
									<div className="col-4">
										<input className="form-control" placeholder="First" />
									</div>
									<div className="col-4">
										<input className="form-control" placeholder="Middle" />
									</div>
									<div className="col-4">
										<input className="form-control" placeholder="Last" />
									</div>
								</div>
							</div>
							<div className="alert bg-inverse bg-opacity-15">
								<b>Please note:</b> 
								If you change your name, you can't change it again for 60 days. 
								Don't add any unusual capitalization, punctuation, characters or random words. 
								<a href="#/" className="alert-link">Learn more.</a>
							</div>
							<div className="mb-3">
								<label className="form-label">Other Names</label>
								<div>
									<a href="#/" className="btn btn-outline-default"><i className="fa fa-plus fa-fw"></i> Add other names</a>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-outline-default" data-bs-dismiss="modal">Close</button>
							<button type="button" className="btn btn-outline-theme">Save changes</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Settings;